import { render, staticRenderFns } from "./ExtraField.vue?vue&type=template&id=08822597&scoped=true&"
import script from "./ExtraField.vue?vue&type=script&lang=js&"
export * from "./ExtraField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08822597",
  null
  
)

export default component.exports